import {
  ExtendedTypography,
  type ExtendedClientGridColumnHeaderProps,
} from '@issuemanager/apps/client/components';
import { useAtlasTheme } from '@issuemanager/apps/client/theme';
import { Box, Stack, Tooltip, styled } from '@mui/material';
import { JSX } from 'react';
import { GridSortableHeader } from './grid-sortable-header';

const StyledStack = styled(Stack)`
  cursor: pointer;
`;

export function ClientGridHeader(
  params: ExtendedClientGridColumnHeaderProps,
): JSX.Element {
  const { colDef, sortModel, onSortModelChange } = params;
  const { headerName, renderHeaderFilter } = colDef;
  const { field } = params;
  const theme = useAtlasTheme();

  const handleClick = (): void => {
    if (!colDef.sortable) return;

    const existingSort = sortModel?.find((sort) => sort.field === field);
    if (!existingSort) {
      onSortModelChange?.([{ field, sort: 'asc' }]);
      return;
    }

    if (existingSort.sort === 'asc') {
      onSortModelChange?.([{ field, sort: 'desc' }]);
      return;
    }

    if (existingSort.sort === 'desc') {
      onSortModelChange?.([]);
    }
  };

  const sortData = sortModel?.find((sort) => sort.field === field);
  const isAscending = sortData?.sort === 'asc';
  const isDescending = sortData?.sort === 'desc';

  return (
    <StyledStack
      spacing={1.5}
      onClick={handleClick}
      height={1}
      width={1}
      padding={1.5}
    >
      <Stack direction='row' spacing={1}>
        <Tooltip
          {...theme.presets.TooltipPresets.type.dark}
          title={
            <ExtendedTypography variant='textSm'>
              {headerName}
            </ExtendedTypography>
          }
        >
          <Box
            overflow='hidden'
            textOverflow='ellipsis'
            width={colDef.computedWidth}
          >
            <ExtendedTypography variant='textSm' fontWeight={600} noWrap>
              {headerName}
            </ExtendedTypography>
          </Box>
        </Tooltip>

        {colDef.sortable ? (
          <GridSortableHeader
            isAscending={isAscending}
            isDescending={isDescending}
          />
        ) : null}
      </Stack>

      <Box onClick={(e) => e.stopPropagation()}>
        {renderHeaderFilter?.(params)}
      </Box>
    </StyledStack>
  );
}
